import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Somes = () => {
	

	return (
		<div className='container' >
		<td>
		<NavLink to='/category/Interview question/2'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

<div class="concepts">
<a > Aptitude Concepts</a>
</div>
<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right'}}> Topics: <b>Average</b></h3>
</div>

<br /> <br /> <br /> <br />

<br />

<p class="pq">1) What is the average of first five multiples of 12?</p>
<ol type="A">
<li className='list'>36</li>                                                 
<li className='list'>38</li>
<li className='list'>40</li>                                                  
<li className='list'>42</li>
</ol>

<Collapsible triggerClassName='showanswer'  trigger="Show answer">
<div class="testanswer" id="answer1">
<p>The correct answer is <strong>A</strong></p>
<p><strong>Explanation:</strong></p>
<p>Average = 12∗(1+2+3+4+5) ∗ <img src="https://static.javatpoint.com/aptitude/images/average15.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 15 "/></p>
<p>= 12 ∗ 15∗  <img src="https://static.javatpoint.com/aptitude/images/average16.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 16 "/></p>
<p>= 12 ∗ 3= 36</p>
</div></Collapsible>
<br />
<p class="pq">2) Average of five numbers is 20. If each number is multiplied by 2, what will be the new average?</p>
<ol type="A">
<li className='list'>30</li>                                                  
<li className='list'>40</li>
<li className='list'>50</li>                                                  
<li className='list'>60</li>
</ol>
<Collapsible triggerClassName='showanswer'  trigger="Show answer"class="showanswer" onclick="showhide(2)">
 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p>The correct answer is <strong>B</strong></p>
<p><strong>Explanation:</strong></p>
<p>The new average = Initial average ∗ 2</p>
<p>= 20 ∗ 2 = 40</p>
</div>
</Collapsible>
<br />
<p class="pq">3) If the average of three consecutive even numbers is 34, find the largest of these numbers.</p>
<ol type="A">
<li className='list'>30</li>                                                       
<li className='list'>32</li> 
<li className='list'>34</li>                                                        
<li className='list'>36</li>  
</ol>
<Collapsible triggerClassName='showanswer'  trigger="Show answer"class="showanswer" onclick="showhide(3)">
 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p>The correct answer is <strong>D</strong></p>
<p><strong>Explanation:</strong></p>
<p>Let the first number is X, then the next two even numbers would be X+2, X+4</p>
<p>As per question;</p>
<p><img src="https://static.javatpoint.com/aptitude/images/average17.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 17 "/> = 34</p>
<p><img src="https://static.javatpoint.com/aptitude/images/average18.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 18 "/> = 34</p>
<p>3X + 6 = 102</p>
<p>3X = 96</p>
<p>X = 32</p>
<p>Largest number would be = 32 + 4 = 36</p>
</div>
</Collapsible>
<br />

<p class="pq">4) 10 typists can type 600 pages in 8 hours.Find the average number of pages typed by each typist in an hour.</p>
<ol type="A">
<li className='list'>7 pages</li>                                                       
<li className='list'>7.5 pages</li> 
<li className='list'>8 pages</li>                                                        
<li className='list'>8.5 pages</li>  
</ol>
<Collapsible triggerClassName='showanswer'  trigger="Show answer"class="showanswer" onclick="showhide(4)">

<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p>The correct answer is <strong>B</strong></p>
<p><strong>Explanation:</strong></p>
<p>Total pages typed by 10 typists in 8 hours = 600</p>
<p>Pages typed by one typist in 8 hours = <img src="https://static.javatpoint.com/aptitude/images/average19.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 19 "/> = 60 pages</p>
<p>Pages typed by one typist in one hour = <img src="https://static.javatpoint.com/aptitude/images/average20.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 20 "/> = 7.5 pages</p>
</div>
</Collapsible>
<br />
<p class="pq">5) The average of Sohan's marks in 6 subjects is 74. If his average in five subjects excluding science is 70, how many marks he obtained in science?</p>
<ol type="A">
<li className='list'>94</li>                                                               
<li className='list'>92</li>
<li className='list'>90</li>                                                               
<li className='list'>88</li> 
</ol>
<Collapsible triggerClassName='showanswer'  trigger="Show answer"class="showanswer" onclick="showhide(5)">

<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p>The correct answer is <strong>A</strong></p>
<p><strong>Explanation:</strong></p>
<p>Total marks obtained in 6 subjects = 6 ∗ 74 = 444</p>
<p>Total marks in 5 subjects excluding science = 5 ∗ 70 = 350</p>
<p>Therefore, marks obtained in science would be = 444 - 350 = 94</p>
</div> 
</Collapsible>
<br />

<p class="pq">6) Average age of a group of 30 boys is 16 years. A boy of age 19  leaves the group and a new boy joins the group. If the new average age of the group is 15.8 years, find the age of the new boy.</p>
<ol type="A">
<li className='list'>12 years</li>                                                        
<li className='list'>13 years</li>
<li className='list'>14 years</li>                                                          
<li className='list'>15 years</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(1)" trigger='Show Answer'>
 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p>The correct answer is <strong>B</strong></p>
<p><strong>Explanation:</strong></p>
<p>Let the age of new boy = X years</p>
<p>Total age of 30 boys = 30*16 = 480 years</p>
<p>As per question, if we minus age of boy who leaves the group and then add the age of boy who joins the group the new average becomes = 15.8 years.</p>
<p>∴ <img src="https://static.javatpoint.com/aptitude/images/average21.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 21 "/> = 15.8</p>
<p>480 - 19 + X = 474</p>
<p>X = 474 - 480 +19</p>
<p>X = - 6 +19</p>
<p>= 13 years</p>
</div></Collapsible>
<br />
<p class="pq">7) The average weight of 10 men is decreased by 2 kg when one of them whose weight is 60 kg is replaced by a new man. What is the weight of the new man? </p>
<ol type="A">
<li className='list'>35 kg</li>                                                    
<li className='list'>40 kg</li> 
<li className='list'>45 kg</li>                                                    
<li className='list'>50 kg</li> 
</ol>
<Collapsible className="showanswer" onclick="showhide(2)" trigger='Show Answer'>
 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p>The correct answer is <strong>B</strong></p>
<p><strong>Explanation:</strong></p>
<p>Average decrease in weight per person = 2kg</p>
<p>There are 10 men so total decrease in weight on replacing a man with a new man = 10 ∗ 2= 20 kg</p>
<p>Weight of the man who is replaced = 60 kg</p>
<p>∴The weight of the new man would be = Weight of man replaced - total decrease in weight of the group of 10 men.</p>
<p>= 60 - 20 = 40 kg</p>
</div></Collapsible>
<br />
<p class="pq">8) The average age of 30 boys in a class is 15 years. If we include the age of two teachers the average age increases by 1. Find the sum of ages of the two teachers.</p>
<ol type="A">
<li className='list'>55 years</li>                                  
<li className='list'>58 years</li>  
<li className='list'>62 years</li>                                  
<li className='list'>64 years</li> 
</ol>
<Collapsible className="showanswer" onclick="showhide(3)" trigger='Show Answer'>
 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p>The correct answer is <strong>C</strong></p>
<p><strong>Explanation:</strong></p>
<p>Total age of 30 boys would be = 30∗15 = 450 years</p>
<p>Total age of 30 boys and 2 teachers would be = 32∗16= 512 years</p>
<p>∴ Sum of ages of two teachers would be = 512 - 450 = 62 years</p>
</div></Collapsible>
<br />
<p class="pq">9) The average age of the committee of 10 members is 40 years.  A member of age 52 retires and a new member of age 38 takes his place. What is the average age of the present committee?</p>
<ol type="A">
<li className='list'>38.6 years</li>                                     
<li className='list'>33.5 years</li> 
<li className='list'>35.5 years</li>                                     
<li className='list'>37.5 years</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(4)" trigger='Show Answer'>
 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p>The correct answer is <strong>A</strong></p>
<p><strong>Explanation:</strong></p>
<p>Total age of the committee = 10 ∗ 40 = 400 years</p> 
<p>Age of retired member = 52 years</p>
<p>Age of new member = 38 years</p>
<p>As per question, we will minus 52 years and add 38 years in the total age then divide by 10 to find the new average age of the committee.</p>
<p>∴ <img src="https://static.javatpoint.com/aptitude/images/average22.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 22 "/></p>
<p>= <img src="https://static.javatpoint.com/aptitude/images/average23.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 23 "/> = <img src="https://static.javatpoint.com/aptitude/images/average24.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Average 24 "/> = = 38.6 years</p>
</div></Collapsible>
<br />
<p class="pq">10) Four years ago, the average age of A and B was 20 years.  If  today average age of A, B and C is 25 years, what will be age of C after 7 years?</p>
<ol type="A">
<li className='list'>32 years</li>                                                       
<li className='list'>34 years</li> 
<li className='list'>36 years</li>                                                       
<li className='list'>38 years</li> 
</ol>
<Collapsible className="showanswer" onclick="showhide(5)" trigger='Show Answer'>
 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p>The correct answer is <strong>B</strong></p>
<p><strong>Explanation:</strong></p>
<p>Total age of A and B four years ago = 20 ∗ 2 = 40 years</p>
<p>Present total age of A and B would be =  40 + 4∗2 = 48 years</p>
<p>Present total age of A, B and C is = 25 ∗ 3 = 75 years</p>
<p>∴ Present age of C would be = 75 - 48 = 27 years</p>
<p>Age of C after 7 years = 27 + 7 = 34 years</p>
</div></Collapsible>
<br />
<br/><br/>



<p class="pq">11) What is the average of first five natural numbers?</p>
<ol type="A">
<li className='list'>5</li>
<li className='list'>2</li>
<li className='list'>3</li>
<li className='list'>4</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(1)" trigger='Show Answer'>
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong> <br/></p>
<img src="https://static.javatpoint.com/aptitude/images/average-aptitude-q11.png" alt="Average Aptitude"/>
<p>Sum of first five natural numbers =1+2+3+4+5 = 15<br/>
Number of quantities = 5<br/>
On putting these values in formula:<br/>
Average = 15/5<br/>
= 3</p>
</div></Collapsible> 
<br />

<p class="pq">12) If the sum is 240 and average is 40, find the number of quantities.</p>
<ol type="A">
<li className='list'>5</li>
<li className='list'>8</li>
<li className='list'>5</li>
<li className='list'>6</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(2)" trigger='Show Answer'>
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong> <br/>
<img src="https://static.javatpoint.com/aptitude/images/average-aptitude-q12.png" alt="Average Aptitude"/><br/>
So, Number of Quantities =240/40<br/>
=6</p>
</div></Collapsible> 
<br />

<p class="pq">13) A group consists of two male, two female and three children. The average age of the male is 67 years, that of the female is 35 years, and that of the children is six years. What is the average age of the group?</p>
<ol type="A">
<li className='list'>30.71</li>
<li className='list'>31.71</li>
<li className='list'>28.71</li>
<li className='list'>35.45</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong> <br/>
Average = (67*2+35*2+6*3) /7<br/>
= (134+70+18) /7<br/>
= 222 /7<br/>
= 31.71</p>
</div></Collapsible>
<br />

<p class="pq">14) Mohan gets a salary of Rs. 6435, Rs. 6927, Rs. 6855, Rs. 7230 and Rs. 6562 for 5 months. How much salary he must have in the sixth month so that he gets an average of Rs. 6500? </p>
<ol type="A">
<li className='list'>4091</li>
<li className='list'>4991</li>
<li className='list'>3499</li>
<li className='list'>3344</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(4)" trigger='Show Answer'>
<div class="testanswer" id="answer4">
<div id="workspace4"></div>
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong> <br/>
Total salary for 5 months = Rs. (6435 + 6927 + 6855 + 7230 + 6562) = Rs. 34009.<br/>
Required salary = Rs. [ (6500 x 6) - 34009 ]<br/>
= Rs. (39000 - 34009)<br/>
= Rs. 4991</p>
</div></Collapsible> 

<br />

<p class="pq">15) If the average of 20 numbers is zero, how many numbers may be greater than zero?</p>
<ol type="A">
<li className='list'>19</li>
<li className='list'>49</li>
<li className='list'>17</li>
<li className='list'>33</li>
</ol>
<span className='dangr'>
<Collapsible className="showanswer" onclick="showhide(5)" trigger='Show Answer'>
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong> <br/>
Average of 20 numbers = 0.<br/>
Sum of 20 numbers = (0 x 20) = 0.<br/>
So, it is quite possible that 19 of these numbers may be positive and if their sum is "X" then 20th number will be (-X).</p>
</div></Collapsible> </span>
<br />

<p class="pq">16) The average weight of 8 women increases by 2.5 kg when a new woman replaces one of them weighing 65 kg. Find the weight of the new woman.</p>
<ol type="A">
<li className='list'>20</li>
<li className='list'>85</li>
<li className='list'>67</li>
<li className='list'>80</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(1)"trigger='Show Answer'>

<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong> <br/>
Total weight increased = (8 x 2.5) kg = 20 kg.<br/>
So, weight of new woman = (65 + 20) kg = 85 kg.</p>
</div>
<br />
</Collapsible>
<p class="pq">17) The captain of a cricket team of 11 members is 26 years old, and the wicket-keeper is three years older than the captain. If the ages of captain and wicketkeeper are excluded, the average age of the remaining players of the team is one year less than the average age of the whole team. What is the average age of the team?</p>
<ol type="A">
<li className='list'>19</li>
<li className='list'>49</li>
<li className='list'>17</li>
<li className='list'>23</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(2)"trigger='Show Answer'>

<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong> <br/>
Let the average age of the whole team by x years.<br/>
11x - (26 + 29) = 9(x -1)<br/>
11x - 55 = 9x -9 <br/>
11x - 9x = - 9 + 55<br/>
2x = 46<br/>
x = 23 Years.</p>
</div>
<br />
</Collapsible>
<p class="pq">18) The average monthly income of Rakesh and Suresh is Rs. 5050. The average monthly income of Suresh and Ramesh is Rs. 6250 and the average monthly income of Rakesh and Ramesh is Rs. 5200. What is the monthly income of Rakesh?</p>
<ol type="A">
<li className='list'>3000</li>
<li className='list'>6000</li>
<li className='list'>4000</li>
<li className='list'>2500</li>
</ol> 

<Collapsible className="showanswer" onclick="showhide(3)"trigger='Show Answer'>

<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong> <br/>
Rakesh +Suresh (total income) = 5050 x 2 = 10100.... (i)<br/>
Suresh +Ramesh (total income) = 6250 x 2 = 12500.... (ii)<br/>
Rakesh+ Ramesh (total income) = 5200 x 2 = 10400.... (iii)</p>
<p>Adding (i), (ii) and (iii), we get: 2(P + Q + R) = 33000 or P + Q + R = 16500.... (iv)<br/>
Subtracting (ii) from (iv), we get P = 4000.<br/>
So, Rakesh's monthly income = Rs. 4000.</p>
</div>
<br />
</Collapsible>
<p class="pq">19) Three years ago, the average age of Anita, Priya, and Varsha was 27 years. If five years ago, the average age of Priya and Varsha was 20 years, find the present age of Anita.</p>
<ol type="A">
<li className='list'>30</li>
<li className='list'>40</li>
<li className='list'>60</li>
<li className='list'>25</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(4)"trigger='Show Answer'>

<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong> <br/>
Sum of the present ages of Anita, Priya and Varsha = (27 x 3 + 3 x 3) years = 90 years.<br/>
Sum of the present ages of Priya and Varsha = (20 x 2 + 5 x 2) years = 50 years.<br/>
Anita's present age = (90 - 50) years = 40 years.</p>
</div>
<br />
</Collapsible>
<p class="pq">20) In Varun's opinion, his weight is greater than 65 kg but less than 72 kg. His father does not agree with Varun, and he thinks that Varun's weight is greater than 60 kg but less than 70 kg. His sister's view is that his weight cannot be greater than 68 kg. If all are correct in their estimation, what is the average of the different possible weights of Varun?</p>
<ol type="A">
<li className='list'>60</li>
<li className='list'>65</li>
<li className='list'>67</li>
<li className='list'>54</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(5)"trigger='Show Answer'>

<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong> <br/>
Let Arun's weight by X kg.<br/>
According to Varun: 65 &lt;&lt;X &lt; 72<br/>
According to Varun's father: 60 &lt; X &lt; 70.<br/>
According to Varun's sister: X &lt;= 68<br/>
The different possible weights of Varun or the values that satisfy all the above conditions are 66, 67 and 68.<br/>
So, the Average of different possible weights of Varun = (66+67+68) / 3<br/>
= 201/3<br/>
= 67 kg.</p>
</div>
<br />
</Collapsible>

<p class="pq">26) If the number of quantities in group A is 10 and in group B is 8, and their individual average is 24 and 16 respectively, find the combined average of the two groups. </p>
<ol type="A">
<li className='list'>20.44</li>
<li className='list'>18.22</li>
<li className='list'>16.22</li>
<li className='list'>18.66</li>
</ol>
<Collapsible className="showanswer"  onclick="showhide(1)" trigger='Show Answer' >
 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong> <br/>
The combined average of the two groups is =<br/>
<img src="https://static.javatpoint.com/aptitude/images/average-aptitude-q26.png" alt="Average Aptitude"/><br/>
=(10*24+8*16)/(10+8)<br/>
= (240+128)/18<br/>
= 368/18<br/>
= 20.44</p>
</div></Collapsible>
<br />

<p class="pq">27) The average of square of first 6 consecutive even numbers is:</p>
<ol type="A">
<li className='list'>12.20</li>
<li className='list'>60.66</li>
<li className='list'>16.45</li>
<li className='list'>178</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(2)" trigger='Show Answer'>
 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong> <br/>
<img src="https://static.javatpoint.com/aptitude/images/average-aptitude-q27.png" alt="Average Aptitude"/><br/>
Here, n=6<br/>
So, Average = 2 (6+1) (2*6+1)/3<br/>
=2*7*13/3<br/>
= 182 /3<br/>
= 60.66</p>
</div> </Collapsible>
<br />

<p class="pq">28) Find the average of first 4 consecutive even numbers.</p>
<ol type="A">
<li className='list'>2</li>
<li className='list'>5</li>
<li className='list'>1</li>
<li className='list'>8</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(3)" trigger='Show Answer'>
 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong> <br/>
Average of first n consecutive even numbers is given by:<br/>
Average= n+1<br/>
Here, n=4<br/>
So, the average = 4+1=5</p>
</div> </Collapsible>
<br />

<p class="pq">29) Find the average of first 5 consecutive even numbers starting from 2 to 10, where the last even number is 10.</p>
<ol type="A">
<li className='list'>1</li>
<li className='list'>6</li>
<li className='list'>2</li>
<li className='list'>8</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(4)" trigger='Show Answer'>
 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong> <br/>
The average of first n consecutive even numbers starting from 2 to X, where the last even number is X, is given by: <br/>
= (X+2)/2 <br/>
Here, X=10<br/>
So, the required average = (10+2)/2<br/>
= 12/2<br/>
=6</p>
</div> </Collapsible>
<br />

<p class="pq">30) Find the average of the square of first 6 consecutive even numbers starting from 2 to 12, where the last even number is 12.</p>
<ol type="A">
<li className='list'>12.20</li>
<li className='list'>60.66</li>
<li className='list'>16.45</li>
<li className='list'>178</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(5)" trigger='Show Answer'>
 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong> <br/>
<img src="https://static.javatpoint.com/aptitude/images/average-aptitude-q30.png" alt="Average Aptitude"/><br/>
<img src="https://static.javatpoint.com/aptitude/images/average-aptitude-q30_1.png" alt="Average Aptitude"/><br/>
=13*14/3<br/>
= 182/3<br/>
= 60.66</p>
</div> </Collapsible>
<br />

</td>


<p class="pq">31) Find the average of first 20 consecutive natural numbers.</p>
<ol type="A">
<li className='list'>12.20</li>
<li className='list'>10.78</li>
<li className='list'>16.45</li>
<li className='list'>10.5</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(1)" trigger='Show Answer'>
 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong> <br/>
The average of first n consecutive natural numbers is given by;<br/>
=(n+1)/2<br/>
Here, n=20<br/>
So, average = (20+1)/2<br/>
=210/20<br/>
=21/2<br/>
=10.5 </p>
</div></Collapsible>
<br />

<p class="pq">32) Find the average of square of first 5 consecutive natural numbers.</p>
<ol type="A">
<li className='list'>12</li>
<li className='list'>10</li>
<li className='list'>16</li>
<li className='list'>11</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(2)" trigger='Show Answer'>
 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong> <br/>
The average of square of first n consecutive natural numbers is given by; <br/>
=   (n+1) (2n+1) / 6<br/>
Here, n=5<br/>
=   (5+1) (2*5+1)/6  <br/>      
= 6*11/6<br/>
= 11</p>
</div></Collapsible>
<br />

<p class="pq">33) Find the average of cubes of first 7 consecutive natural numbers.</p>
<ol type="A">
<li className='list'>112</li>
<li className='list'>110</li>
<li className='list'>116</li>
<li className='list'>113</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(3)" trigger='Show Answer'>
 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong> <br/>
The average of cubes of first n consecutive natural numbers is given by; <br/>
= n (n+1)²/4 <br/>
Here, n=7<br/>
= 7 (7+1)²/4   <br/>     
= 7*64/4<br/>
=448/4<br/>
= 112</p>
</div></Collapsible>
<br />

<p class="pq">34) Find the average of first 8 consecutive odd numbers.</p>
<ol type="A">
<li className='list'>11</li>
<li className='list'>10</li>
<li className='list'>8</li>
<li className='list'>12</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(4)" trigger='Show Answer'>
 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong> <br/>
The average of first n consecutive odd numbers is equal to n, so the average of first 8 consecutive odd numbers is 8.<br/>
You can check by solving it as show below:<br/>
= (1+ 3+ 5+ 7+ 9+ 11+ 13+ 15)/8<br/>
= 64/8 = 8</p>
</div></Collapsible>
<br />

<p class="pq">35) Find the average of the square of first 5 consecutive odd numbers starting from 1 to 9, where the last odd number is 9.</p>
<ol type="A">
<li className='list'>22</li>
<li className='list'>11</li>
<li className='list'>16</li>
<li className='list'>33</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(5)" trigger='Show Answer'>
 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong> <br/>
The average of square of first n consecutive odd numbers starting from 1 to X, where the last odd number is X, is given by:<br/>
=X(X+2)/3<br/>
Here, X=9<br/>
So, average =9(9+2)/3<br/>
=9*11/3<br/>
=99/3<br/>
=33</p>
</div></Collapsible>
<br />

<p class="pq">36) The average age of a group of 6 boys is 19. If the new average age after a boy joins the group is 21.28, find the age of new boy.</p>
<ol type="A">
<li className='list'>Approx 23</li>
<li className='list'>Approx 32</li>
<li className='list'>Approx 35</li>
<li className='list'>Approx 45</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(1)" trigger='Show my answer'>
 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong> <br/>
Use Formula:<br/>
Age of new body= New average + Number of boys initially * increase in average   <br/>
= 21.28 + 6*2.28<br/>
=21.28 + 13.68<br/>
= 34.96</p>
</div></Collapsible>
<br />

<p class="pq">37) The average weight of a group of 5 boys is 26. If we replace a boy of weight 25 in the group with another boy so that new average increases by 3, find the weight of the new body.</p>
<ol type="A">
<li className='list'>56</li>
<li className='list'>34</li>
<li className='list'>40</li>
<li className='list'>33</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(2)" trigger='Show my answer'>
 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong> <br/>
The weight of new person = Weight of the removed person + No. of persons * Increase in average.<br/>
= 25+5*3<br/>
=25+15<br/>
= 40</p>
</div></Collapsible>
<br />

<p class="pq">38) Find the average of first 6 consecutive even numbers.</p>
<ol type="A">
<li className='list'>6</li>
<li className='list'>4</li>
<li className='list'>0</li>
<li className='list'>7</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(3)" trigger='Show my answer'>
 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong> <br/>
The average of first n consecutive even numbers is given by:<br/>
= n+1<br/>
Here, n=6<br/>
= 6+1<br/>
= 7</p>
</div></Collapsible>
<br />

<p class="pq">39) Find the average of first 9 consecutive odd numbers.</p>
<ol type="A">
<li className='list'>9</li>
<li className='list'>4</li>
<li className='list'>0</li>
<li className='list'>7</li>
</ol>
<Collapsible className="showanswer" onclick="showhide(4)" trigger='Show my answer'>
 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> A</p>
<p><strong>Solution:</strong> <br/>
The average of first n consecutive odd numbers is equal to n.<br/>
Here, n=9<br/>
So, it is 9.</p>
</div>
</Collapsible>
			</div>
			
	)
}

export default Somes
